<template>
  <v-app>
    <div class="esport-admin-page">
      <header class="navbar">
        <div class="navbar-inner">
          <div class="logo-section">
            <div class="logo-wrapper">
              <img src="/images/icon2.png" alt="logo" class="logo" />
            </div>

            <div>
              <h2>
                Diskominfo E-Sport
                <span class="admin-tag">Bracket</span>
              </h2>

              <p>Bondowoso Berkah</p>
            </div>
          </div>
        </div>
      </header>

      <main class="esport-container">
        <div class="section-heading">
          <div class="eyebrow">
            <v-icon small>mdi-soccer</v-icon>
            TURNAMEN PRO EVOLUTION SOCCER
          </div>

          <h1>Bracket Turnamen PES</h1>

          <p>
            Generate bracket otomatis dari pendaftar PES. Drag and drop peserta juga bisa
            dilakukan lo.........
          </p>
        </div>

        <v-card class="modern-card pilih-card">
          <div class="pilih-inner">
            <div class="pilih-info">
              <v-icon small color="#018c74"> mdi-information-outline </v-icon>

              <span>
                Bracket khusus untuk lomba
                <strong>Pro Evolution Soccer</strong>
              </span>
            </div>

            <div class="pilih-actions">
              <v-btn
                depressed
                class="refresh-btn"
                :loading="loading"
                @click="fetchBracket"
              >
                <v-icon left small> mdi-refresh </v-icon>
                Refresh
              </v-btn>

              <v-btn
                v-if="bracket"
                depressed
                class="reset-btn-outline"
                :loading="lanjutkanBabakSedangDiproses"
                @click="lanjutkanBabakManual"
              >
                <v-icon left small> mdi-arrow-right-bold-box-outline </v-icon>
                Lanjutkan Babak
              </v-btn>

              <v-btn
                v-if="bracket"
                depressed
                class="reset-btn-outline"
                @click="resetBracket"
              >
                <v-icon left small> mdi-restart </v-icon>
                Reset Bracket
              </v-btn>
            </div>
          </div>
        </v-card>

        <v-card
          v-if="!loading && !bracket && totalSlotUntukProyeksi < 2"
          class="modern-card empty-bracket-card"
        >
          <div class="empty-icon">
            <v-icon size="46" color="#018c74"> mdi-tournament </v-icon>
          </div>

          <h3>Bracket belum bisa diproyeksikan</h3>

          <p>
            Minimal 2 peserta (slot) yang <strong>Terverifikasi</strong> dibutuhkan agar
            proyeksi bagan bisa ditampilkan.
          </p>
        </v-card>

        <template v-if="totalSlotUntukProyeksi >= 2">
          <v-card v-if="!loading && !bracket" class="modern-card empty-bracket-card">
            <div class="empty-icon">
              <v-icon size="46" color="#018c74"> mdi-tournament </v-icon>
            </div>

            <h3>Bracket belum digenerate</h3>

            <p>
              Sistem akan mengambil pendaftar
              <strong>PES yang sudah Terverifikasi</strong>
            </p>

            <v-btn
              depressed
              class="export-btn"
              :loading="generating"
              @click="generateBracket"
            >
              <v-icon left small> mdi-sitemap </v-icon>
              Generate Bracket
            </v-btn>
          </v-card>

          <div class="summary-grid" v-if="bracket">
            <div class="summary-card total">
              <div class="summary-icon"><v-icon>mdi-account-group</v-icon></div>
              <div>
                <span>Total Peserta (Slot)</span>
                <strong>{{ peserta.length }}</strong>
              </div>
            </div>

            <div class="summary-card ai">
              <div class="summary-icon"><v-icon>mdi-sitemap</v-icon></div>
              <div>
                <span>Status Bracket</span>
                <strong class="cap">{{ bracket.status }}</strong>
              </div>
            </div>

            <div class="summary-card menunggu">
              <div class="summary-icon"><v-icon>mdi-clock-outline</v-icon></div>
              <div>
                <span>Match Menunggu</span>
                <strong>{{ totalMenungguSkor }}</strong>
              </div>
            </div>

            <div class="summary-card diterima">
              <div class="summary-icon"><v-icon>mdi-check-circle-outline</v-icon></div>
              <div>
                <span>Match Selesai</span>
                <strong>{{ totalSelesai }}</strong>
              </div>
            </div>
          </div>

          <v-card
            v-if="bracket && (bracket.status === 'selesai' || bracket.juara_1_id)"
            class="modern-card juara-card"
          >
            <div class="juara-title">
              <v-icon color="#d97706"> mdi-trophy </v-icon>
              <strong> Hasil Akhir Turnamen </strong>
            </div>

            <div class="juara-grid">
              <div class="juara-box juara-1">
                <div class="juara-number">1</div>
                <div>
                  <span>Juara 1</span>
                  <strong>{{ namaPeserta(bracket.juara_1_id) }}</strong>
                </div>
              </div>

              <div class="juara-box juara-2">
                <div class="juara-number">2</div>
                <div>
                  <span>Juara 2</span>
                  <strong>{{ namaPeserta(bracket.juara_2_id) }}</strong>
                </div>
              </div>

              <div v-if="bracket.juara_3_id" class="juara-box juara-3">
                <div class="juara-number">3</div>
                <div>
                  <span>Juara 3</span>
                  <strong>{{ namaPeserta(bracket.juara_3_id) }}</strong>
                </div>
              </div>

              <div v-if="bracket.juara_4_id" class="juara-box juara-4">
                <div class="juara-number">4</div>
                <div>
                  <span>Juara 4</span>
                  <strong>{{ namaPeserta(bracket.juara_4_id) }}</strong>
                </div>
              </div>
            </div>
          </v-card>

          <v-card class="modern-card bracket-scroll-card">
            <div class="table-title">
              <div class="table-title-left">
                <div class="table-title-icon">
                  <v-icon small color="#018c74"> mdi-tournament </v-icon>
                </div>

                <div>
                  <strong>Papan Bracket</strong>
                  <span>
                    {{
                      bracket
                        ? "Isi skor sebagai catatan (opsional, bisa direvisi kapan saja), lalu klik tombol trofi nama pemenang untuk memajukannya ke babak berikutnya."
                        : "Proyeksi bagan berdasarkan jumlah pendaftar terverifikasi saat ini."
                    }}
                  </span>
                </div>
              </div>

              <div class="bracket-nav-controls">
                <div class="mode-pill-group" role="group" aria-label="Mode interaksi">
                  <button
                    type="button"
                    class="mode-pill-btn"
                    :class="{ active: !handActive }"
                    title="Mode Pilih: klik &amp; seret kartu/peserta (tombol V)"
                    @click="setHandMode(false)"
                  >
                    <v-icon x-small>mdi-cursor-default-outline</v-icon>
                    <span>Pilih</span>
                    <kbd class="mode-kbd">V</kbd>
                  </button>

                  <button
                    type="button"
                    class="mode-pill-btn hand"
                    :class="{ active: handActive }"
                    title="Mode Tangan: tarik papan untuk geser kiri/kanan (tombol H, atau tahan Spasi)"
                    @click="setHandMode(true)"
                  >
                    <v-icon x-small>mdi-hand-back-right-outline</v-icon>
                    <span>Tangan</span>
                    <kbd class="mode-kbd">H</kbd>
                  </button>
                </div>

                <v-btn
                  depressed
                  class="screenshot-action-btn"
                  :loading="capturingScreenshot"
                  title="Ambil gambar bagan pertandingan secara utuh"
                  @click="takeScreenshot"
                >
                  <v-icon left small color="#018c74">mdi-camera-outline</v-icon>
                  <span>Screenshot Bagan</span>
                </v-btn>

                <div class="jump-pill-group">
                  <button
                    type="button"
                    class="jump-pill-btn"
                    :class="{ active: !canScrollLeft }"
                    title="Lompat ke Pool A (Sisi Kiri)"
                    @click="scrollToPolA"
                  >
                    <v-icon x-small color="#018c74">mdi-arrow-left</v-icon>
                    <span>POL A</span>
                  </button>

                  <button
                    type="button"
                    class="jump-pill-btn final-pill"
                    title="Lompat ke Final / Babak Tengah"
                    @click="scrollToFinal"
                  >
                    <v-icon x-small color="#d97706">mdi-trophy-outline</v-icon>
                    <span>FINAL</span>
                  </button>

                  <button
                    type="button"
                    class="jump-pill-btn"
                    :class="{ active: !canScrollRight }"
                    title="Lompat ke Pool B (Sisi Kanan)"
                    @click="scrollToPolB"
                  >
                    <span>POL B</span>
                    <v-icon x-small color="#018c74">mdi-arrow-right</v-icon>
                  </button>
                </div>

                <div class="step-nav-group">
                  <button
                    type="button"
                    class="step-nav-btn"
                    :disabled="!canScrollLeft"
                    title="Geser ke kiri (POL A)"
                    @click="scrollStep(-1)"
                  >
                    <v-icon small>mdi-chevron-left</v-icon>
                  </button>

                  <button
                    type="button"
                    class="step-nav-btn"
                    :disabled="!canScrollRight"
                    title="Geser ke kanan (POL B)"
                    @click="scrollStep(1)"
                  >
                    <v-icon small>mdi-chevron-right</v-icon>
                  </button>
                </div>
              </div>
            </div>

            <transition name="fade">
              <div v-if="handActive && !isDragging" class="hand-mode-hint">
                <v-icon x-small color="#ffffff">{{
                  isPanning ? "mdi-hand-back-right" : "mdi-hand-back-right-outline"
                }}</v-icon>
                <span>
                  {{
                    spaceHeld
                      ? "Spasi ditahan — tarik papan untuk geser"
                      : "Mode Tangan aktif — tarik papan ke kiri/kanan"
                  }}
                  <em>(V = Pilih · Tahan Spasi = tangan sementara)</em>
                </span>
              </div>
            </transition>

            <transition name="fade">
              <div
                v-if="isDragging && canScrollLeft"
                class="drag-scroll-guide left-guide"
                :class="{ active: activeScrollDirection === 'left' }"
              >
                <div class="drag-guide-content">
                  <div class="drag-guide-icon-pulse">
                    <v-icon small color="#018c74">mdi-chevron-double-left</v-icon>
                  </div>
                  <div class="drag-guide-text">
                    <strong>POL A</strong>
                    <small>{{
                      activeScrollDirection === "left"
                        ? "Menggeser..."
                        : "Bawa ke tepi untuk geser"
                    }}</small>
                  </div>
                </div>
              </div>
            </transition>

            <transition name="fade">
              <div
                v-if="isDragging && canScrollRight"
                class="drag-scroll-guide right-guide"
                :class="{ active: activeScrollDirection === 'right' }"
              >
                <div class="drag-guide-content">
                  <div class="drag-guide-text right-align">
                    <strong>POL B</strong>
                    <small>{{
                      activeScrollDirection === "right"
                        ? "Menggeser..."
                        : "Bawa ke tepi untuk geser"
                    }}</small>
                  </div>
                  <div class="drag-guide-icon-pulse">
                    <v-icon small color="#018c74">mdi-chevron-double-right</v-icon>
                  </div>
                </div>
              </div>
            </transition>

            <transition name="fade">
              <div
                v-if="isDragging && activeScrollDirectionY === 'up'"
                class="drag-scroll-guide-v top-guide-v"
              >
                <div class="drag-guide-content">
                  <div class="drag-guide-icon-pulse">
                    <v-icon small color="#018c74">mdi-chevron-double-up</v-icon>
                  </div>
                  <div class="drag-guide-text">
                    <strong>GESER KE ATAS</strong>
                    <small>Menggulir layar...</small>
                  </div>
                </div>
              </div>
            </transition>

            <transition name="fade">
              <div
                v-if="isDragging && activeScrollDirectionY === 'down'"
                class="drag-scroll-guide-v bottom-guide-v"
              >
                <div class="drag-guide-content">
                  <div class="drag-guide-icon-pulse">
                    <v-icon small color="#018c74">mdi-chevron-double-down</v-icon>
                  </div>
                  <div class="drag-guide-text">
                    <strong>GESER KE BAWAH</strong>
                    <small>Menggulir layar...</small>
                  </div>
                </div>
              </div>
            </transition>

            <div
              class="bracket-scroll"
              :class="{ 'hand-mode': handActive, 'is-panning': isPanning }"
              ref="bracketScroll"
              @scroll="checkScrollBounds"
              @mousedown="onPanMouseDown"
              @dragstart.capture="onPanDragStartCapture"
              @click.capture="onPanClickCapture"
            >
              <svg ref="bracketSvg" class="bracket-svg" aria-hidden="true"></svg>

              <div class="bracket-track">
                <div class="bracket-side-group bracket-side-group-left">
                  <div class="bracket-side-title">
                    <v-icon small color="#018c74"
                      >mdi-arrow-left-bold-circle-outline</v-icon
                    >
                    <span>POL A</span>
                  </div>

                  <div class="bracket-half bracket-half-left">
                    <div
                      v-for="grp in sideRounds.left"
                      :key="'L-' + grp.ronde"
                      class="bracket-column"
                    >
                      <div class="bracket-column-header">
                        <div class="round-icon">
                          <v-icon small> mdi-format-list-numbered </v-icon>
                        </div>
                        <span>{{ grp.label }}</span>
                      </div>

                      <div class="bracket-column-action">
                        <v-btn
                          v-if="bisaAcakRonde(grp.ronde)"
                          depressed
                          small
                          class="acak-ronde-btn"
                          :loading="acakRondeSedangDiproses === grp.ronde"
                          :title="`Acak semua pemain ${grp.label} (POL A + POL B)`"
                          @click.stop="acakRonde(grp)"
                        >
                          <v-icon left small>mdi-shuffle-variant</v-icon>
                          Acak Pemain
                        </v-btn>
                      </div>

                      <div class="bracket-column-body">
                        <div class="bracket-column-cards">
                          <EsportMatchCard
                            v-for="m in grp.matches"
                            :key="m.id"
                            :match="m"
                            :nama1="namaPeserta(m.peserta1_id)"
                            :nama2="namaPeserta(m.peserta2_id)"
                            :input-state="matchInputs[m.id]"
                            @simpan="simpanSkor(m)"
                            @tentukan-pemenang="tentukanPemenang(m, $event)"
                            @set-jadwal="onSetJadwal(m, $event)"
                            @rematch="rematchPertandingan(m)"
                            @mundur="mundurkanBabakPertandingan(m)"
                            @drag-start="onCardDragStart"
                            @drag-end="onCardDragEnd"
                            @drop="onCardDrop"
                            @card-drag-start="onCardHeaderDragStart"
                            @card-drag-end="onCardHeaderDragEnd"
                            @card-drop="onCardHeaderDrop"
                          />
                          <div
                            v-if="grp.matches.some((m) => !m.isPlaceholder)"
                            class="bracket-add-match"
                            :class="{
                              'drop-hover': addMatchHoverKey === 'kiri-' + grp.ronde,
                            }"
                            @dragenter.prevent="addMatchHoverKey = 'kiri-' + grp.ronde"
                            @dragover.prevent
                            @dragleave="addMatchHoverKey = null"
                            @drop.prevent="onDropTambahMatchBaru('kiri', grp.ronde)"
                          >
                            <v-icon small>mdi-plus-circle-outline</v-icon>
                            <span>Seret peserta ke sini untuk match baru</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="bracket-center">
                  <div class="bracket-side-title center-spacer" aria-hidden="true">
                    <v-icon small>mdi-arrow-left-bold-circle-outline</v-icon>
                    <span>POL A</span>
                  </div>
                  <div
                    class="bracket-column-header center-spacer-header"
                    aria-hidden="true"
                  ></div>
                  <div class="center-spacer-action" aria-hidden="true"></div>

                  <div class="bracket-center-body">
                    <div class="final-block">
                      <div class="final-label">
                        <v-icon small color="#d97706">mdi-trophy-outline</v-icon>
                        <span>Final</span>
                      </div>

                      <div class="final-card-wrap">
                        <EsportMatchCard
                          :match="finalDisplay"
                          :nama1="namaPeserta(finalDisplay.peserta1_id)"
                          :nama2="namaPeserta(finalDisplay.peserta2_id)"
                          :input-state="matchInputs[finalDisplay.id]"
                          variant="final"
                          @simpan="simpanSkor(finalDisplay)"
                          @tentukan-pemenang="tentukanPemenang(finalDisplay, $event)"
                          @set-jadwal="onSetJadwal(finalDisplay, $event)"
                          @rematch="rematchPertandingan(finalDisplay)"
                          @drag-start="onCardDragStart"
                          @drag-end="onCardDragEnd"
                          @drop="onCardDrop"
                          @card-drag-start="onCardHeaderDragStart"
                          @card-drag-end="onCardHeaderDragEnd"
                          @card-drop="onCardHeaderDrop"
                        />
                      </div>
                    </div>

                    <div v-if="juara3Display" class="j3-block">
                      <div class="j3-label">
                        <v-icon x-small color="#3b82f6">mdi-medal-outline</v-icon>
                        <span>Perebutan Juara 3</span>
                      </div>

                      <EsportMatchCard
                        :match="juara3Display"
                        :nama1="namaPeserta(juara3Display.peserta1_id)"
                        :nama2="namaPeserta(juara3Display.peserta2_id)"
                        :input-state="matchInputs[juara3Display.id]"
                        variant="small"
                        @simpan="simpanSkor(juara3Display)"
                        @tentukan-pemenang="tentukanPemenang(juara3Display, $event)"
                        @set-jadwal="onSetJadwal(juara3Display, $event)"
                        @rematch="rematchPertandingan(juara3Display)"
                        @drag-start="onCardDragStart"
                        @drag-end="onCardDragEnd"
                        @drop="onCardDrop"
                        @card-drag-start="onCardHeaderDragStart"
                        @card-drag-end="onCardHeaderDragEnd"
                        @card-drop="onCardHeaderDrop"
                      />
                    </div>
                  </div>
                </div>

                <div class="bracket-side-group bracket-side-group-right">
                  <div class="bracket-side-title">
                    <span>POL B</span>
                    <v-icon small color="#018c74"
                      >mdi-arrow-right-bold-circle-outline</v-icon
                    >
                  </div>

                  <div class="bracket-half bracket-half-right">
                    <div
                      v-for="grp in sideRounds.right"
                      :key="'R-' + grp.ronde"
                      class="bracket-column"
                    >
                      <div class="bracket-column-header">
                        <span>{{ grp.label }}</span>
                        <div class="round-icon">
                          <v-icon small> mdi-format-list-numbered </v-icon>
                        </div>
                      </div>

                      <div class="bracket-column-action">
                        <v-btn
                          v-if="bisaAcakRonde(grp.ronde)"
                          depressed
                          small
                          class="acak-ronde-btn"
                          :loading="acakRondeSedangDiproses === grp.ronde"
                          :title="`Acak semua pemain ${grp.label} (POL A + POL B)`"
                          @click.stop="acakRonde(grp)"
                        >
                          <v-icon left small>mdi-shuffle-variant</v-icon>
                          Acak Pemain
                        </v-btn>
                      </div>

                      <div class="bracket-column-body">
                        <div class="bracket-column-cards">
                          <EsportMatchCard
                            v-for="m in grp.matches"
                            :key="m.id"
                            :match="m"
                            :nama1="namaPeserta(m.peserta1_id)"
                            :nama2="namaPeserta(m.peserta2_id)"
                            :input-state="matchInputs[m.id]"
                            @simpan="simpanSkor(m)"
                            @tentukan-pemenang="tentukanPemenang(m, $event)"
                            @set-jadwal="onSetJadwal(m, $event)"
                            @rematch="rematchPertandingan(m)"
                            @mundur="mundurkanBabakPertandingan(m)"
                            @drag-start="onCardDragStart"
                            @drag-end="onCardDragEnd"
                            @drop="onCardDrop"
                            @card-drag-start="onCardHeaderDragStart"
                            @card-drag-end="onCardHeaderDragEnd"
                            @card-drop="onCardHeaderDrop"
                          />
                          <div
                            v-if="grp.matches.some((m) => !m.isPlaceholder)"
                            class="bracket-add-match"
                            :class="{
                              'drop-hover': addMatchHoverKey === 'kanan-' + grp.ronde,
                            }"
                            @dragenter.prevent="addMatchHoverKey = 'kanan-' + grp.ronde"
                            @dragover.prevent
                            @dragleave="addMatchHoverKey = null"
                            @drop.prevent="onDropTambahMatchBaru('kanan', grp.ronde)"
                          >
                            <v-icon small>mdi-plus-circle-outline</v-icon>
                            <span>Seret peserta ke sini untuk match baru</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </template>
      </main>

      <v-dialog
        v-model="screenshotDialogOpen"
        max-width="1240"
        scrollable
        content-class="screenshot-preview-dialog"
      >
        <v-card class="screenshot-dialog-card">
          <div class="screenshot-dialog-header">
            <div class="header-left">
              <div class="header-icon-box">
                <v-icon color="#018c74">mdi-image-filter-center-focus</v-icon>
              </div>
              <div class="header-title-text">
                <h3>Preview Bagan Pertandingan</h3>
                <p>
                  Ukuran:
                  <strong
                    >{{ screenshotDimensions.width }} ×
                    {{ screenshotDimensions.height }} px</strong
                  >
                  <span class="dot-separator">•</span>
                  {{ screenshotDimensions.dateStr }}
                </p>
              </div>
              <button
                type="button"
                class="close-dialog-btn mobile-close-btn"
                title="Tutup Preview"
                @click="screenshotDialogOpen = false"
              >
                <v-icon small>mdi-close</v-icon>
              </button>
            </div>

            <div class="header-tools">
              <div class="zoom-pill-group">
                <button
                  type="button"
                  class="zoom-btn"
                  title="Perkecil (-)"
                  :disabled="zoomPercent <= 30"
                  @click="zoomOut"
                >
                  <v-icon small>mdi-minus</v-icon>
                </button>
                <span
                  class="zoom-value"
                  @click="resetZoom"
                  title="Klik untuk sesuaikan ke lebar layar"
                >
                  {{ zoomPercent }}%
                </span>
                <button
                  type="button"
                  class="zoom-btn"
                  title="Perbesar (+)"
                  :disabled="zoomPercent >= 500"
                  @click="zoomIn"
                >
                  <v-icon small>mdi-plus</v-icon>
                </button>
              </div>

              <button
                type="button"
                class="tool-btn"
                :class="{ active: zoomMode === 'fit' || zoomPercent === 100 }"
                title="Sesuaikan ukuran ke lebar layar modal"
                @click="setZoomMode('fit')"
              >
                <v-icon small>mdi-arrow-expand-horizontal</v-icon>
                <span>Pas Layar</span>
              </button>

              <button
                type="button"
                class="tool-btn"
                :class="{ active: zoomMode === 'actual' }"
                title="Tampilkan ukuran 100% asli"
                @click="setZoomMode('actual')"
              >
                <v-icon small>mdi-magnify-plus-outline</v-icon>
                <span>100% Asli</span>
              </button>

              <button
                type="button"
                class="close-dialog-btn desktop-close-btn"
                title="Tutup Preview"
                @click="screenshotDialogOpen = false"
              >
                <v-icon small>mdi-close</v-icon>
              </button>
            </div>
          </div>

          <v-card-text class="screenshot-dialog-body">
            <div class="screenshot-canvas-viewport">
              <div class="screenshot-img-container" :style="imageContainerStyle">
                <img
                  v-if="screenshotImgUrl"
                  :src="screenshotImgUrl"
                  alt="Tangkapan Layar Bagan Pertandingan"
                  class="screenshot-result-image"
                />
              </div>
            </div>
            <div class="viewport-hint">
              <v-icon x-small color="#94a3b8">mdi-information-outline</v-icon>
              <span
                >Tips: Gunakan tombol zoom di atas atau scroll untuk melihat detail.</span
              >
            </div>
          </v-card-text>

          <v-card-actions class="screenshot-dialog-footer">
            <div class="footer-meta">
              <v-chip small color="#e6f7f3" text-color="#018c74" class="font-weight-bold">
                <v-icon left x-small color="#018c74">mdi-file-png-box</v-icon>
                PNG HD
              </v-chip>
              <span class="file-name-preview">Bagan-PES-Bondowoso-Berkah.png</span>
            </div>

            <div class="footer-buttons">
              <div class="footer-secondary-btns">
                <v-btn outlined class="cancel-btn" @click="screenshotDialogOpen = false">
                  <v-icon left small>mdi-close</v-icon>
                  <span>Tutup</span>
                </v-btn>

                <v-btn
                  outlined
                  class="open-tab-btn"
                  title="Buka gambar penuh di tab browser baru"
                  @click="bukaDiTabBaru"
                >
                  <v-icon left small>mdi-open-in-new</v-icon>
                  <span>Tab Baru</span>
                </v-btn>
              </div>

              <v-btn
                depressed
                class="download-btn"
                title="Simpan file gambar PNG ke perangkat Anda"
                @click="downloadScreenshot"
              >
                <v-icon left small>mdi-download</v-icon>
                <span>Download Gambar (PNG)</span>
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        timeout="3000"
        top
        right
      >
        {{ snackbar.text }}
      </v-snackbar>
    </div>
  </v-app>
</template>

<script setup>
import { ref, computed, reactive, onMounted, onBeforeUnmount, nextTick } from "vue";
import axios from "axios";
import html2canvas from "html2canvas";
import EsportMatchCard from "./EsportMatchCard.vue";

const API_BASE = "https://berkah.bondowosokab.go.id:5500";
const ADMIN_API_KEY = "7039338ec2fa8ac649760ddd8404b711b207479377c846d41d5d24b7b21beb97";
const authHeaders = { headers: { "Bondowoso-Berkah": ADMIN_API_KEY } };

const capturingScreenshot = ref(false);
const screenshotDialogOpen = ref(false);
const screenshotImgUrl = ref("");
const screenshotDimensions = ref({ width: 0, height: 0, dateStr: "" });
const zoomPercent = ref(100);
const zoomMode = ref("fit");

const setZoomMode = (mode) => {
  zoomMode.value = mode;
  if (mode === "fit") {
    zoomPercent.value = 100;
  } else if (mode === "actual") {
    const targetW = screenshotDimensions.value.width
      ? Math.round(screenshotDimensions.value.width / 2)
      : 2400;
    const vp = document.querySelector(".screenshot-canvas-viewport");
    const vpWidth = vp ? Math.max(300, vp.clientWidth - 40) : 1100;
    zoomPercent.value = Math.max(100, Math.round((targetW / vpWidth) * 100));
  }
};

const zoomIn = () => {
  zoomMode.value = "custom";
  zoomPercent.value = Math.min(500, zoomPercent.value + 25);
};

const zoomOut = () => {
  zoomMode.value = "custom";
  zoomPercent.value = Math.max(30, zoomPercent.value - 25);
};

const resetZoom = () => {
  setZoomMode("fit");
};

const imageContainerStyle = computed(() => {
  if (zoomMode.value === "fit" || zoomPercent.value === 100) {
    return {
      width: "100%",
      maxWidth: "100%",
      minWidth: "100%",
      margin: "0 auto",
      display: "block",
    };
  }
  return {
    width: `${zoomPercent.value}%`,
    maxWidth: "none",
    minWidth: `${zoomPercent.value}%`,
    margin: "0 auto",
    display: "block",
  };
});

const takeScreenshot = async () => {
  const container = bracketScroll.value;
  if (!container) {
    notify("Papan bagan belum siap diambil screenshot.", "error");
    return;
  }

  capturingScreenshot.value = true;
  notify("Sedang memproses screenshot bagan keseluruhan...", "info");

  const savedScrollLeft = container.scrollLeft;
  const savedScrollTop = container.scrollTop;

  try {
    if (document.fonts && document.fonts.ready) {
      await document.fonts.ready;
    }

    container.scrollLeft = 0;
    container.scrollTop = 0;

    await nextTick();
    drawBracketLines();
    await new Promise((resolve) => setTimeout(resolve, 200));

    const fullWidth = container.scrollWidth;
    const fullHeight = container.scrollHeight;

    const bgImg = await new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = "/images/bglivepes.png";
    });

    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: null,
      width: fullWidth,
      height: fullHeight,
      scrollX: 0,
      scrollY: 0,
      onclone: (clonedDoc) => {
        const clonedScroll = clonedDoc.querySelector(".bracket-scroll");
        if (clonedScroll) {
          clonedScroll.style.overflow = "visible";
          clonedScroll.style.width = fullWidth + "px";
          clonedScroll.style.height = fullHeight + "px";
          clonedScroll.style.maxWidth = "none";
          clonedScroll.style.maxHeight = "none";
          clonedScroll.style.scrollLeft = 0;
          clonedScroll.scrollTop = 0;
          clonedScroll.style.background = "transparent";

          const clonedSvg = clonedScroll.querySelector(".bracket-svg");
          if (clonedSvg) {
            drawBracketLines(clonedScroll, clonedSvg);
          }
        }
      },
      ignoreElements: (element) => {
        return (
          element.classList &&
          (element.classList.contains("drag-scroll-guide") ||
            element.classList.contains("drag-scroll-guide-v") ||
            element.classList.contains("hand-mode-hint") ||
            element.classList.contains("bracket-add-match") ||
            element.classList.contains("acak-ronde-btn"))
        );
      },
    });

    const scaleFactor = Math.max(1, canvas.width / 2000);
    const headerHeight = Math.round(110 * scaleFactor);
    const footerHeight = Math.round(40 * scaleFactor);
    const padX = Math.round(40 * scaleFactor);

    const finalCanvas = document.createElement("canvas");
    finalCanvas.width = canvas.width;
    finalCanvas.height = canvas.height + headerHeight + footerHeight;

    const ctx = finalCanvas.getContext("2d");

    const bgGradient = ctx.createLinearGradient(
      0,
      0,
      finalCanvas.width,
      finalCanvas.height
    );
    bgGradient.addColorStop(0, "#e8f5f1");
    bgGradient.addColorStop(0.5, "#f4fbf8");
    bgGradient.addColorStop(1, "#e2f4ef");
    ctx.fillStyle = bgGradient;
    ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

    if (bgImg && bgImg.complete && bgImg.naturalWidth > 0) {
      ctx.drawImage(bgImg, 0, headerHeight, finalCanvas.width, canvas.height);
      ctx.fillStyle = "rgba(236, 247, 244, 0.78)";
      ctx.fillRect(0, headerHeight, finalCanvas.width, canvas.height);
    }

    const gradient = ctx.createLinearGradient(0, 0, finalCanvas.width, 0);
    gradient.addColorStop(0, "#018c74");
    gradient.addColorStop(1, "#0f766e");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, finalCanvas.width, headerHeight);

    const goldBarHeight = Math.max(4, Math.round(4 * scaleFactor));
    ctx.fillStyle = "#f59e0b";
    ctx.fillRect(0, headerHeight - goldBarHeight, finalCanvas.width, goldBarHeight);

    const titleSize = Math.round(28 * scaleFactor);
    const subSize = Math.round(15 * scaleFactor);
    const statusSize = Math.round(16 * scaleFactor);
    const timeSize = Math.round(13 * scaleFactor);
    const footerSize = Math.round(12 * scaleFactor);

    ctx.fillStyle = "#ffffff";
    ctx.font = `bold ${titleSize}px sans-serif`;
    ctx.fillText(
      "TURNAMEN PRO EVOLUTION SOCCER (PES)",
      padX,
      Math.round(headerHeight * 0.44)
    );

    ctx.fillStyle = "#ccfbf1";
    ctx.font = `600 ${subSize}px sans-serif`;
    const totalSlotStr = peserta.value.length
      ? `${peserta.value.length} Slot Peserta`
      : `${totalSlotUntukProyeksi.value} Peserta Terdaftar`;
    ctx.fillText(
      `DISKOMINFO BONDOWOSO BERKAH • BAGAN RESMI PERTANDINGAN • ${totalSlotStr}`,
      padX,
      Math.round(headerHeight * 0.78)
    );

    const waktuCetak = new Date().toLocaleString("id-ID", {
      dateStyle: "medium",
      timeStyle: "short",
    });
    ctx.textAlign = "right";
    ctx.fillStyle = "#fef08a";
    ctx.font = `bold ${statusSize}px sans-serif`;
    const statusText = `STATUS: ${(bracket.value?.status || "AKTIF").toUpperCase()}`;
    ctx.fillText(statusText, finalCanvas.width - padX, Math.round(headerHeight * 0.44));

    ctx.fillStyle = "#e0f2fe";
    ctx.font = `500 ${timeSize}px sans-serif`;
    ctx.fillText(
      `Tangkapan Layar: ${waktuCetak}`,
      finalCanvas.width - padX,
      Math.round(headerHeight * 0.76)
    );

    ctx.textAlign = "left";

    ctx.drawImage(canvas, 0, headerHeight);

    ctx.fillStyle = "#f1f5f9";
    ctx.fillRect(0, finalCanvas.height - footerHeight, finalCanvas.width, footerHeight);
    ctx.fillStyle = "#e2e8f0";
    ctx.fillRect(0, finalCanvas.height - footerHeight, finalCanvas.width, 1);

    ctx.textAlign = "center";
    ctx.fillStyle = "#64748b";
    ctx.font = `500 ${footerSize}px sans-serif`;
    ctx.fillText(
      "© Diskominfo Bondowoso • Turnamen E-Sport Bondowoso Berkah",
      finalCanvas.width / 2,
      finalCanvas.height - Math.round(footerHeight * 0.35)
    );

    screenshotImgUrl.value = finalCanvas.toDataURL("image/png");
    screenshotDimensions.value = {
      width: finalCanvas.width,
      height: finalCanvas.height,
      dateStr: waktuCetak,
    };
    setZoomMode("fit");
    screenshotDialogOpen.value = true;
    notify("Screenshot bagan berhasil dibuat. Silakan tinjau dan unduh!");
  } catch (err) {
    console.error("Gagal mengambil screenshot bagan:", err);
    notify("Gagal mengambil screenshot bagan. Silakan coba kembali.", "error");
  } finally {
    container.scrollLeft = savedScrollLeft;
    container.scrollTop = savedScrollTop;
    requestAnimationFrame(drawBracketLines);
    checkScrollBounds();
    capturingScreenshot.value = false;
  }
};

const downloadScreenshot = () => {
  if (!screenshotImgUrl.value) return;
  const link = document.createElement("a");
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const dateStr = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const timeStr = `${pad(now.getHours())}.${pad(now.getMinutes())}.${pad(
    now.getSeconds()
  )}`;
  link.download = `Bagan-PES-Bondowoso-Berkah-${dateStr}_${timeStr}.png`;
  link.href = screenshotImgUrl.value;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  notify("File gambar bagan pertandingan berhasil diunduh.");
};

const bukaDiTabBaru = () => {
  if (!screenshotImgUrl.value) return;
  const w = window.open("");
  if (w) {
    w.document.write(`
      <html>
        <head>
          <title>Bagan Pertandingan PES - Bondowoso Berkah</title>
          <style>
            body {
              margin: 0;
              padding: 24px;
              background: #0f172a;
              display: flex;
              flex-direction: column;
              align-items: center;
              font-family: sans-serif;
            }
            img {
              max-width: 100%;
              height: auto;
              border-radius: 10px;
              box-shadow: 0 15px 40px rgba(0,0,0,0.6);
            }
            .info {
              color: #94a3b8;
              font-size: 13px;
              margin-bottom: 16px;
            }
          </style>
        </head>
        <body>
          <div class="info">Bagan Pertandingan PES - Bondowoso Berkah (Resolusi Tinggi)</div>
          <img src="${screenshotImgUrl.value}" alt="Bagan Pertandingan" />
        </body>
      </html>
    `);
    w.document.close();
  }
};

const selectedJenis = ref("PRO EVOLUTION SOCCER");
const loading = ref(false);
const generating = ref(false);
const bracket = ref(null);
const peserta = ref([]);
const matches = ref([]);

const estimasiTotalSlot = ref(0);

const bracketScroll = ref(null);
const bracketSvg = ref(null);

const matchInputs = reactive({});

const draggedSource = ref(null);
const draggedCard = ref(null);
const isDragging = ref(false);
const activeScrollDirection = ref(null);
const activeScrollDirectionY = ref(null);
const canScrollLeft = ref(false);
const canScrollRight = ref(false);

let autoScrollRaf = null;
let autoScrollVelocityX = 0;
let autoScrollVelocityY = 0;

const snackbar = ref({ show: false, text: "", color: "success" });
const notify = (text, color = "success") => {
  snackbar.value = { show: true, text, color };
};

/* =========================================================
   MODE TANGAN (HAND / PAN MODE)
   - Aktif: tarik papan bracket dengan mouse untuk geser kiri/kanan
     (dan sedikit geser halaman ke atas/bawah), ada efek inersia.
   - Drag & drop kartu otomatis dinonaktifkan selama mode ini aktif.
   - Shortcut keyboard: tekan "H" untuk ganti mode.
   ========================================================= */
const handMode = ref(false);
const isPanning = ref(false);
const spaceHeld = ref(false);
const handActive = computed(() => handMode.value || spaceHeld.value);

let panStartX = 0;
let panStartY = 0;
let panStartScrollLeft = 0;
let panStartScrollY = 0;
let panLastX = 0;
let panLastTime = 0;
let panVelocity = 0;
let panMoved = false;
let panInertiaRaf = null;

const stopPanInertia = () => {
  if (panInertiaRaf) {
    cancelAnimationFrame(panInertiaRaf);
    panInertiaRaf = null;
  }
};

const startPanInertia = () => {
  const el = bracketScroll.value;
  if (!el || Math.abs(panVelocity) < 1) return;

  const step = () => {
    const container = bracketScroll.value;
    if (!container || isPanning.value || Math.abs(panVelocity) < 0.5) {
      panInertiaRaf = null;
      return;
    }

    const before = container.scrollLeft;
    // velocity positif = pointer bergerak ke kanan = konten ikut ke kanan = scrollLeft berkurang
    container.scrollLeft -= panVelocity;
    panVelocity *= 0.94;

    if (container.scrollLeft === before) {
      panVelocity = 0;
    }

    checkScrollBounds();
    panInertiaRaf = requestAnimationFrame(step);
  };

  panInertiaRaf = requestAnimationFrame(step);
};

const onPanMouseMove = (e) => {
  if (!isPanning.value) return;
  const el = bracketScroll.value;
  if (!el) return;

  const dx = e.clientX - panStartX;
  const dy = e.clientY - panStartY;

  if (!panMoved && (Math.abs(dx) > 4 || Math.abs(dy) > 4)) {
    panMoved = true;
  }

  el.scrollLeft = panStartScrollLeft - dx;
  window.scrollTo(window.pageXOffset || 0, panStartScrollY - dy);

  const now = performance.now();
  const dt = now - panLastTime;
  if (dt > 0) {
    const instant = ((e.clientX - panLastX) / dt) * 16;
    panVelocity = panVelocity * 0.6 + instant * 0.4;
  }
  panLastX = e.clientX;
  panLastTime = now;

  checkScrollBounds();
};

const endPan = () => {
  if (!isPanning.value) return;
  isPanning.value = false;
  window.removeEventListener("mousemove", onPanMouseMove);
  window.removeEventListener("mouseup", endPan);
  window.removeEventListener("blur", endPan);

  // Kalau pointer sempat diam sebelum dilepas, jangan beri inersia
  if (performance.now() - panLastTime > 80) panVelocity = 0;

  // reset flag "sudah digeser" setelah event click bawaan lewat
  setTimeout(() => {
    panMoved = false;
  }, 0);

  startPanInertia();
};

const onPanMouseDown = (e) => {
  // klik kiri saat mode tangan / Spasi ditahan, atau klik tengah (roda mouse) kapan saja
  const isMiddle = e.button === 1;
  if (!isMiddle && (!handActive.value || e.button !== 0)) return;

  const target = e.target;
  if (target && target.closest && target.closest("input, textarea, select")) return;

  const el = bracketScroll.value;
  if (!el) return;

  stopPanInertia();

  isPanning.value = true;
  panMoved = false;
  panVelocity = 0;
  panStartX = e.clientX;
  panStartY = e.clientY;
  panLastX = e.clientX;
  panLastTime = performance.now();
  panStartScrollLeft = el.scrollLeft;
  panStartScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

  window.addEventListener("mousemove", onPanMouseMove);
  window.addEventListener("mouseup", endPan);
  window.addEventListener("blur", endPan);

  // cegah seleksi teks & drag native saat menarik papan
  e.preventDefault();
};

// Selama mode tangan: blok drag & drop bawaan kartu
const onPanDragStartCapture = (e) => {
  if (handActive.value) {
    e.preventDefault();
    e.stopPropagation();
  }
};

// Kalau pointer sudah bergeser (artinya user menarik papan), jangan anggap itu klik
const onPanClickCapture = (e) => {
  if (panMoved) {
    e.preventDefault();
    e.stopPropagation();
    panMoved = false;
  }
};

const setHandMode = (value) => {
  if (handMode.value === value) return;
  handMode.value = value;
  if (!value) {
    endPan();
    stopPanInertia();
  }
  notify(
    value
      ? "Mode Tangan aktif. Tarik papan untuk geser kiri/kanan."
      : "Mode Pilih aktif. Drag & drop peserta bisa dipakai lagi.",
    "info"
  );
};

const isTypingTarget = (el) => {
  if (!el) return false;
  const tag = (el.tagName || "").toLowerCase();
  return (
    tag === "input" || tag === "textarea" || tag === "select" || el.isContentEditable
  );
};

const shortcutAllowed = (e) => {
  if (e.ctrlKey || e.metaKey || e.altKey) return false;
  if (isTypingTarget(e.target)) return false;
  if (screenshotDialogOpen.value) return false;
  if (!bracket.value && totalSlotUntukProyeksi.value < 2) return false;
  return true;
};

// H = Tangan, V = Pilih (kursor), tahan Spasi = tangan sementara
const handleHandModeKey = (e) => {
  if (!shortcutAllowed(e)) return;

  if (e.code === "Space") {
    e.preventDefault(); // cegah halaman ikut scroll
    if (!spaceHeld.value) {
      spaceHeld.value = true;
      stopPanInertia();
    }
    return;
  }

  if (e.repeat) return;
  const key = (e.key || "").toLowerCase();
  if (key === "h") setHandMode(true);
  else if (key === "v") setHandMode(false);
};

const handleHandModeKeyUp = (e) => {
  if (e.code !== "Space" || !spaceHeld.value) return;
  e.preventDefault();
  spaceHeld.value = false;
  if (!handMode.value) endPan();
};

const releaseSpace = () => {
  spaceHeld.value = false;
};

const initMatchInputs = () => {
  for (const key in matchInputs) delete matchInputs[key];
  matches.value.forEach((m) => {
    matchInputs[m.id] = {
      skor1: m.skor1 ?? "",
      skor2: m.skor2 ?? "",
      editing: false,
      saving: false,
    };
  });
};

const fetchBracket = async () => {
  loading.value = true;
  try {
    const { data } = await axios.get(`${API_BASE}/esport/bracket`, {
      ...authHeaders,
      params: { jenis_lomba: selectedJenis.value },
    });

    const payload = data?.response?.data ?? data?.data ?? null;

    if (payload && payload.bracket) {
      bracket.value = payload.bracket;
      peserta.value = payload.peserta || [];
      matches.value = payload.matches || [];
      initMatchInputs();
    } else {
      bracket.value = null;
      peserta.value = [];
      matches.value = [];
      await fetchEstimasiPeserta();
    }

    await nextTick();
    requestAnimationFrame(drawBracketLines);
    checkScrollBounds();
  } catch (err) {
    console.error("Gagal memuat bracket", err);
    notify("Gagal memuat data bracket.", "error");
  } finally {
    loading.value = false;
  }
};

const fetchEstimasiPeserta = async () => {
  try {
    const { data } = await axios.get(`${API_BASE}/esport/pendaftar/admin`, {
      ...authHeaders,
      params: { jenis_lomba: selectedJenis.value },
    });
    const list = data?.response?.data ?? data?.data ?? [];
    estimasiTotalSlot.value = list
      .filter((p) => Number(p.status_verifikasi) === 1)
      .reduce((sum, p) => sum + Math.max(1, Number(p.jumlah_slot) || 1), 0);
  } catch (err) {
    console.error("Gagal memuat estimasi peserta", err);
    estimasiTotalSlot.value = 0;
  }
};

const generateBracket = async () => {
  if (
    !confirm(
      `Generate bracket untuk ${selectedJenis.value}? Pastikan data pendaftar terverifikasi sudah benar.`
    )
  )
    return;

  generating.value = true;
  try {
    await axios.post(
      `${API_BASE}/esport/bracket/generate`,
      { jenis_lomba: selectedJenis.value },
      authHeaders
    );
    notify("Bracket berhasil digenerate.");
    await fetchBracket();
  } catch (err) {
    console.error("Gagal generate bracket", err);
    notify(err?.response?.data?.message || "Gagal generate bracket.", "error");
  } finally {
    generating.value = false;
  }
};

const resetBracket = async () => {
  if (
    !confirm(
      "Yakin reset bracket ini? Semua skor & babak yang sudah dibuat akan terhapus permanen."
    )
  )
    return;

  try {
    await axios.post(
      `${API_BASE}/esport/bracket/reset`,
      { jenis_lomba: selectedJenis.value },
      authHeaders
    );
    notify("Bracket berhasil direset.");
    await fetchBracket();
  } catch (err) {
    console.error("Gagal reset bracket", err);
    notify("Gagal reset bracket.", "error");
  }
};

const simpanSkor = async (m) => {
  if (m.isPlaceholder) return;
  const input = matchInputs[m.id];
  if (!input) return;

  if (input.skor1 === "" || input.skor2 === "") {
    notify("Isi skor kedua peserta terlebih dahulu.", "error");
    return;
  }

  input.saving = true;
  try {
    await axios.put(
      `${API_BASE}/esport/bracket/match/${m.id}/skor`,
      { skor1: Number(input.skor1), skor2: Number(input.skor2) },
      authHeaders
    );
    notify("Skor berhasil disimpan.");
    await fetchBracket();
  } catch (err) {
    console.error("Gagal menyimpan skor", err);
    notify(err?.response?.data?.message || "Gagal menyimpan skor.", "error");
  } finally {
    if (matchInputs[m.id]) matchInputs[m.id].saving = false;
  }
};

const rematchPertandingan = async (m) => {
  if (!m || m.isPlaceholder || m.status !== "selesai") return;

  if (
    !confirm(
      "Reset match ini untuk tanding ulang? Skor & pemenang akan dihapus. Kalau babak berikutnya sudah terbentuk dari hasil match ini, babak tersebut (termasuk Final/Juara 3 jika ada) juga akan dihapus dan dibuat ulang otomatis nanti."
    )
  )
    return;

  try {
    await axios.put(`${API_BASE}/esport/bracket/match/${m.id}/rematch`, {}, authHeaders);
    notify("Match berhasil direset untuk tanding ulang.");
    await fetchBracket();
  } catch (err) {
    console.error("Gagal rematch", err);
    notify(err?.response?.data?.message || "Gagal mereset match.", "error");
  }
};

const mundurkanBabakPertandingan = async (m) => {
  if (!m || m.isPlaceholder) return;

  if (
    !confirm(
      "Mundurkan babak ini? Match akan dihapus dan pesertanya kembali ke posisi sebelum babak ini dibuat (babak asalnya tidak berubah)."
    )
  )
    return;

  try {
    await axios.put(`${API_BASE}/esport/bracket/match/${m.id}/mundur`, {}, authHeaders);
    notify("Babak berhasil dimundurkan.");
    await fetchBracket();
  } catch (err) {
    console.error("Gagal memundurkan babak", err);
    notify(err?.response?.data?.message || "Gagal memundurkan babak.", "error");
  }
};

const tentukanPemenang = async (m, pemenangId) => {
  if (!m || m.isPlaceholder || !pemenangId) return;

  const namaTerpilih =
    pemenangId === m.peserta1_id
      ? namaPeserta(m.peserta1_id)
      : namaPeserta(m.peserta2_id);

  if (
    !confirm(
      `Tetapkan "${namaTerpilih}" sebagai pemenang match ini? Pemenang akan otomatis maju ke babak berikutnya.`
    )
  )
    return;

  try {
    await axios.put(
      `${API_BASE}/esport/bracket/match/${m.id}/pemenang`,
      { pemenang_id: pemenangId },
      authHeaders
    );
    notify(`Pemenang ditetapkan: ${namaTerpilih}.`);
    await fetchBracket();
  } catch (err) {
    console.error("Gagal menetapkan pemenang", err);
    notify(err?.response?.data?.message || "Gagal menetapkan pemenang.", "error");
  }
};

const onSetJadwal = async (m, payload) => {
  if (!m || m.isPlaceholder) return;

  try {
    await axios.put(
      `${API_BASE}/esport/bracket/match/${m.id}/jadwal`,
      payload,
      authHeaders
    );
    notify(
      payload?.clear
        ? "Jadwal berhasil dihapus."
        : payload?.menit === 0
        ? "Match ditandai Live sekarang."
        : `Countdown diatur: mulai dalam ${payload.menit} menit.`
    );
    await fetchBracket();
  } catch (err) {
    console.error("Gagal mengatur jadwal", err);
    notify(err?.response?.data?.message || "Gagal mengatur jadwal.", "error");
  }
};

const checkScrollBounds = () => {
  const el = bracketScroll.value;
  if (!el) return;
  canScrollLeft.value = el.scrollLeft > 15;
  canScrollRight.value = el.scrollLeft < el.scrollWidth - el.clientWidth - 15;
};

const scrollToPolA = () => {
  if (!bracketScroll.value) return;
  stopPanInertia();
  bracketScroll.value.scrollTo({ left: 0, behavior: "smooth" });
};

const scrollToFinal = () => {
  if (!bracketScroll.value) return;
  stopPanInertia();
  const container = bracketScroll.value;
  const finalEl = container.querySelector(".bracket-center");
  if (finalEl) {
    const finalRect = finalEl.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const targetScroll =
      container.scrollLeft +
      (finalRect.left - containerRect.left) -
      container.clientWidth / 2 +
      finalRect.width / 2;
    container.scrollTo({ left: Math.max(0, targetScroll), behavior: "smooth" });
  } else {
    container.scrollTo({
      left: Math.max(0, (container.scrollWidth - container.clientWidth) / 2),
      behavior: "smooth",
    });
  }
};

const scrollToPolB = () => {
  if (!bracketScroll.value) return;
  stopPanInertia();
  bracketScroll.value.scrollTo({
    left: bracketScroll.value.scrollWidth - bracketScroll.value.clientWidth,
    behavior: "smooth",
  });
};

const scrollStep = (direction) => {
  if (!bracketScroll.value) return;
  stopPanInertia();
  bracketScroll.value.scrollBy({ left: direction * 450, behavior: "smooth" });
};

const autoScrollStep = () => {
  if (!isDragging.value || (autoScrollVelocityX === 0 && autoScrollVelocityY === 0)) {
    autoScrollRaf = null;
    activeScrollDirection.value = null;
    activeScrollDirectionY.value = null;
    return;
  }

  const container = bracketScroll.value;

  if (container && autoScrollVelocityX !== 0) {
    container.scrollLeft += autoScrollVelocityX;

    if (autoScrollVelocityX < 0 && container.scrollLeft <= 2) {
      autoScrollVelocityX = 0;
      activeScrollDirection.value = null;
    } else if (
      autoScrollVelocityX > 0 &&
      container.scrollLeft >= container.scrollWidth - container.clientWidth - 2
    ) {
      autoScrollVelocityX = 0;
      activeScrollDirection.value = null;
    }

    checkScrollBounds();
  }

  if (autoScrollVelocityY !== 0) {
    const scrollY =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    const maxScrollY = Math.max(
      0,
      (document.documentElement.scrollHeight || document.body.scrollHeight) -
        window.innerHeight
    );

    if (autoScrollVelocityY < 0 && scrollY <= 2) {
      autoScrollVelocityY = 0;
      activeScrollDirectionY.value = null;
    } else if (autoScrollVelocityY > 0 && scrollY >= maxScrollY - 2) {
      autoScrollVelocityY = 0;
      activeScrollDirectionY.value = null;
    } else {
      window.scrollBy(0, autoScrollVelocityY);
    }
  }

  if (autoScrollVelocityX !== 0 || autoScrollVelocityY !== 0) {
    autoScrollRaf = requestAnimationFrame(autoScrollStep);
  } else {
    autoScrollRaf = null;
  }
};

const stopAutoScroll = () => {
  autoScrollVelocityX = 0;
  autoScrollVelocityY = 0;
  activeScrollDirection.value = null;
  activeScrollDirectionY.value = null;
  if (autoScrollRaf) {
    cancelAnimationFrame(autoScrollRaf);
    autoScrollRaf = null;
  }
};

const stopDragAndAutoScroll = () => {
  isDragging.value = false;
  draggedSource.value = null;
  stopAutoScroll();
};

const handleGlobalDragOver = (e) => {
  if (!isDragging.value || !bracketScroll.value) return;

  const container = bracketScroll.value;
  const rect = container.getBoundingClientRect();

  if (e.clientX < rect.left - 180 || e.clientX > rect.right + 180) {
    stopAutoScroll();
    return;
  }

  const edgeThresholdX = 180;
  const maxSpeedX = 34;
  const minSpeedX = 8;
  let velX = 0;

  if (e.clientX <= rect.left + edgeThresholdX) {
    const dist = rect.left + edgeThresholdX - e.clientX;
    const ratio = Math.min(1, Math.max(0.15, dist / edgeThresholdX));
    velX = -(minSpeedX + ratio * (maxSpeedX - minSpeedX));
    activeScrollDirection.value = "left";
  } else if (e.clientX >= rect.right - edgeThresholdX) {
    const dist = e.clientX - (rect.right - edgeThresholdX);
    const ratio = Math.min(1, Math.max(0.15, dist / edgeThresholdX));
    velX = minSpeedX + ratio * (maxSpeedX - minSpeedX);
    activeScrollDirection.value = "right";
  } else {
    activeScrollDirection.value = null;
  }

  const edgeThresholdY = 140;
  const maxSpeedY = 28;
  const minSpeedY = 7;
  let velY = 0;

  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  if (e.clientY <= edgeThresholdY) {
    const dist = edgeThresholdY - e.clientY;
    const ratio = Math.min(1, Math.max(0.15, dist / edgeThresholdY));
    velY = -(minSpeedY + ratio * (maxSpeedY - minSpeedY));
    activeScrollDirectionY.value = "up";
  } else if (e.clientY >= viewportHeight - edgeThresholdY) {
    const dist = e.clientY - (viewportHeight - edgeThresholdY);
    const ratio = Math.min(1, Math.max(0.15, dist / edgeThresholdY));
    velY = minSpeedY + ratio * (maxSpeedY - minSpeedY);
    activeScrollDirectionY.value = "down";
  } else {
    activeScrollDirectionY.value = null;
  }

  autoScrollVelocityX = velX;
  autoScrollVelocityY = velY;

  if (autoScrollVelocityX !== 0 || autoScrollVelocityY !== 0) {
    if (!autoScrollRaf) {
      autoScrollRaf = requestAnimationFrame(autoScrollStep);
    }
  } else {
    stopAutoScroll();
  }
};

const onCardDragStart = (payload) => {
  if (handActive.value) return;
  draggedSource.value = payload;
  isDragging.value = true;
  checkScrollBounds();
};

const onCardDragEnd = () => {
  stopDragAndAutoScroll();
};

const addMatchHoverKey = ref(null);

const onDropTambahMatchBaru = async (sisi, ronde) => {
  const src = draggedSource.value;
  draggedSource.value = null;
  addMatchHoverKey.value = null;
  if (!src) return;

  if (src.ronde !== ronde) {
    notify("Pemisahan hanya bisa dilakukan pada babak yang sama.", "error");
    return;
  }

  const srcMatch = matches.value.find((m) => m.id === src.matchId);
  if (!srcMatch) return;

  if (srcMatch.status !== "menunggu") {
    notify(
      "Hanya peserta dari match 2 orang ('menunggu') yang bisa dipisah jadi match BYE baru.",
      "error"
    );
    return;
  }

  try {
    const { data } = await axios.put(
      `${API_BASE}/esport/bracket/pisah`,
      { match_id: src.matchId, slot: src.slot },
      authHeaders
    );

    if (data?.data?.auto_lanjut === false) {
      notify(
        "Dipisah jadi 2 BYE terpisah. Babak BELUM otomatis lanjut — atur ulang pasangan dulu, lalu klik 'Lanjutkan Babak' kalau sudah siap.",
        "warning"
      );
    } else {
      notify("Berhasil dipisah jadi match BYE baru.");
    }
    await fetchBracket();
  } catch (err) {
    console.error("Gagal memisah peserta", err);
    notify(err?.response?.data?.message || "Gagal memisah peserta.", "error");
  }
};

const lanjutkanBabakSedangDiproses = ref(false);

const lanjutkanBabakManual = async () => {
  if (!bracket.value) return;
  lanjutkanBabakSedangDiproses.value = true;
  try {
    await axios.put(
      `${API_BASE}/esport/bracket/paksa-lanjutkan`,
      { jenis_lomba: selectedJenis.value },
      authHeaders
    );
    notify("Babak berhasil dilanjutkan.");
    await fetchBracket();
  } catch (err) {
    console.error("Gagal melanjutkan babak", err);
    notify(err?.response?.data?.message || "Gagal melanjutkan babak.", "error");
  } finally {
    lanjutkanBabakSedangDiproses.value = false;
  }
};

const onCardDrop = async (payload) => {
  const src = draggedSource.value;
  draggedSource.value = null;
  if (!src) return;
  if (src.matchId === payload.matchId && src.slot === payload.slot) return;

  if (src.ronde !== payload.ronde) {
    notify("Pengaturan ulang hanya bisa dilakukan pada babak yang sama.", "error");
    return;
  }

  const srcMatch = matches.value.find((m) => m.id === src.matchId);
  const dstMatch = matches.value.find((m) => m.id === payload.matchId);
  if (!srcMatch || !dstMatch) return;

  const statusBolehTukar = ["menunggu", "bye"];
  if (
    !statusBolehTukar.includes(srcMatch.status) ||
    !statusBolehTukar.includes(dstMatch.status)
  ) {
    notify(
      "Hanya bisa mengatur ulang peserta pada match yang belum diisi skor.",
      "error"
    );
    return;
  }
  if (srcMatch.status === "bye" && src.slot !== "peserta1") {
    notify("Match BYE hanya punya 1 peserta untuk diseret.", "error");
    return;
  }

  try {
    await axios.put(
      `${API_BASE}/esport/bracket/swap`,
      {
        match1_id: src.matchId,
        slot1: src.slot,
        match2_id: payload.matchId,
        slot2: payload.slot,
      },
      authHeaders
    );
    notify("Bagan berhasil diperbarui.");
    await fetchBracket();
  } catch (err) {
    console.error("Gagal mengatur ulang peserta", err);
    notify(err?.response?.data?.message || "Gagal memperbarui bagan.", "error");
  }
};

const onCardHeaderDragStart = (payload) => {
  if (handActive.value) return;
  draggedCard.value = payload;
  isDragging.value = true;
  checkScrollBounds();
};

const onCardHeaderDragEnd = () => {
  stopDragAndAutoScroll();
  draggedCard.value = null;
};

const onCardHeaderDrop = async (payload) => {
  const src = draggedCard.value;
  draggedCard.value = null;
  if (!src) return;
  if (src.matchId === payload.matchId) return;

  const srcMatch = matches.value.find((m) => m.id === src.matchId);
  const dstMatch = matches.value.find((m) => m.id === payload.matchId);
  if (!srcMatch || !dstMatch) return;

  if (srcMatch.ronde !== dstMatch.ronde) {
    notify("Tukar posisi kartu hanya bisa dilakukan pada babak yang sama.", "error");
    return;
  }
  if (srcMatch.ronde >= 900 || dstMatch.ronde >= 900) {
    notify("Posisi Final / Perebutan Juara 3 tidak bisa ditukar.", "error");
    return;
  }

  try {
    await axios.put(
      `${API_BASE}/esport/bracket/tukar-posisi`,
      {
        match1_id: src.matchId,
        match2_id: payload.matchId,
      },
      authHeaders
    );
    notify("Posisi kedua kartu berhasil ditukar.");
    await fetchBracket();
  } catch (err) {
    console.error("Gagal menukar posisi kartu", err);
    notify(err?.response?.data?.message || "Gagal menukar posisi kartu.", "error");
  }
};

const acakRondeSedangDiproses = ref(null);

// Tombol acak hanya muncul untuk Babak 3 s/d Semifinal, jika semua match di babak
// itu (POL A + POL B) belum selesai dan babak berikutnya belum terbentuk darinya.
const bisaAcakRonde = (ronde) => {
  if (!bracket.value || typeof ronde !== "number" || ronde < 3 || ronde >= 900)
    return false;
  const list = matches.value.filter((m) => m.ronde === ronde);
  if (!list.length) return false;
  if (!list.every((m) => ["menunggu", "bye"].includes(m.status))) return false;

  const ids = new Set(list.map((m) => m.id));
  const sudahAdaTurunan = matches.value.some(
    (m) => ids.has(m.asal_match1_id) || ids.has(m.asal_match2_id)
  );
  return !sudahAdaTurunan;
};

const acakRonde = async (grp) => {
  if (
    !confirm(
      `Acak semua pemain ${grp.label}? Peserta POL A dan POL B pada babak ini akan dicampur ulang, dan skor/jadwal yang sudah diisi di babak ini akan direset.`
    )
  )
    return;

  acakRondeSedangDiproses.value = grp.ronde;
  try {
    await axios.put(
      `${API_BASE}/esport/bracket/acak-ronde`,
      { jenis_lomba: selectedJenis.value, ronde: grp.ronde },
      authHeaders
    );
    notify(`Pemain ${grp.label} berhasil diacak.`);
    await fetchBracket();
  } catch (err) {
    console.error("Gagal mengacak pemain", err);
    notify(err?.response?.data?.message || "Gagal mengacak pemain.", "error");
  } finally {
    acakRondeSedangDiproses.value = null;
  }
};

const namaPeserta = (id) => {
  if (!id) return "—";
  const p = peserta.value.find((x) => x.id === id);
  return p ? p.nama_display : "—";
};

const totalSlotUntukProyeksi = computed(() =>
  peserta.value.length ? peserta.value.length : estimasiTotalSlot.value
);

const hitungByeAdil = (n) => {
  if (n <= 2) return 0;
  const setengah = Math.ceil(n / 2);
  const target = setengah % 2 === 0 ? setengah : setengah + 1;
  return 2 * target - n;
};

const projectedRounds = computed(() => {
  let n = totalSlotUntukProyeksi.value;
  const rounds = [];
  if (!n || n < 2) return rounds;

  let ronde = 1;
  while (n > 2) {
    const bye = ronde === 1 ? hitungByeAdil(n) : n % 2 !== 0 ? 1 : 0;
    const main = n - bye;
    const matchCount = main / 2;
    if (matchCount <= 0) break;

    rounds.push({ ronde, matchCount });
    n = matchCount + bye;
    ronde++;
    if (ronde > 30) break;
  }
  return rounds;
});

const hitungByeAdilSisi = (n) => {
  if (n <= 2) return 0;
  const setengah = Math.ceil(n / 2);
  const target = setengah % 2 === 0 ? setengah : setengah + 1;
  return 2 * target - n;
};

const projectSideRounds = (n) => {
  const counts = [];
  if (n < 1) return counts;
  let cur = n;
  let first = true;
  let guard = 0;
  while (cur > 1) {
    const bye = first ? hitungByeAdilSisi(cur) : cur % 2 !== 0 ? 1 : 0;
    const main = cur - bye;
    const matchCount = Math.max(1, Math.ceil(main / 2));
    counts.push(matchCount + bye);
    cur = matchCount + bye;
    first = false;
    if (++guard > 30) break;
  }
  return counts;
};

const sideSplit = computed(() => {
  const n = totalSlotUntukProyeksi.value;
  if (!n || n < 2) return { nLeft: 0, nRight: 0 };
  const nLeft = Math.ceil(n / 2);
  const nRight = n - nLeft;
  return { nLeft, nRight };
});

const placeholderMatch = (side, ronde, idx) => ({
  id: `placeholder-${side}-${ronde}-${idx}`,
  ronde,
  urutan: idx,
  status: "placeholder",
  peserta1_id: null,
  peserta2_id: null,
  pemenang_id: null,
  isPlaceholder: true,
});

const buildSideColumns = (side, realByRonde, counts, totalRoundsReal) => {
  const totalRounds = Math.max(counts.length, totalRoundsReal, 1);
  const cols = [];

  for (let r = 1; r <= totalRounds; r++) {
    const real = realByRonde[r];

    const roundMatches =
      real && real.length
        ? real
        : Array.from({ length: counts[r - 1] ?? (counts.length ? 1 : 0) }, (_, i) =>
            placeholderMatch(side, r, i)
          );

    const isSemifinal = r === totalRounds;
    const label = isSemifinal ? "Semifinal" : `Babak ${r}`;

    cols.push({ ronde: r, label, matches: roundMatches });
  }

  return cols;
};

const sideRounds = computed(() => {
  const realKiri = {};
  const realKanan = {};
  matches.value.forEach((m) => {
    if (m.ronde >= 900) return;
    if (m.sisi === "kiri") (realKiri[m.ronde] = realKiri[m.ronde] || []).push(m);
    else if (m.sisi === "kanan") (realKanan[m.ronde] = realKanan[m.ronde] || []).push(m);
  });
  Object.values(realKiri).forEach((list) => list.sort((a, b) => a.urutan - b.urutan));
  Object.values(realKanan).forEach((list) => list.sort((a, b) => a.urutan - b.urutan));

  const totalRoundsRealKiri = Object.keys(realKiri).length;
  const totalRoundsRealKanan = Object.keys(realKanan).length;

  const { nLeft, nRight } = sideSplit.value;
  const leftCounts = projectSideRounds(nLeft);
  const rightCounts = projectSideRounds(nRight);

  const left = buildSideColumns("left", realKiri, leftCounts, totalRoundsRealKiri);
  const right = buildSideColumns("right", realKanan, rightCounts, totalRoundsRealKanan);

  right.reverse();

  return { left, right };
});

const finalMatch = computed(() => matches.value.find((m) => m.ronde === 900) || null);
const juara3Match = computed(() => matches.value.find((m) => m.ronde === 901) || null);

const finalDisplay = computed(
  () =>
    finalMatch.value || {
      id: "placeholder-final",
      ronde: 900,
      urutan: 0,
      status: "placeholder",
      peserta1_id: null,
      peserta2_id: null,
      pemenang_id: null,
      isPlaceholder: true,
    }
);

const juara3Display = computed(() => {
  if (juara3Match.value) return juara3Match.value;
  if (projectedRounds.value.length < 1) return null;
  return {
    id: "placeholder-j3",
    ronde: 901,
    urutan: 0,
    status: "placeholder",
    peserta1_id: null,
    peserta2_id: null,
    pemenang_id: null,
    isPlaceholder: true,
  };
});

const totalMenungguSkor = computed(
  () => matches.value.filter((m) => m.status === "menunggu").length
);
const totalSelesai = computed(
  () => matches.value.filter((m) => m.status === "selesai" || m.status === "bye").length
);

const createPath = (svg, d) => {
  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("d", d);
  path.setAttribute("class", "bracket-connector");
  path.setAttribute("fill", "none");
  path.setAttribute("stroke", "#aebcc5");
  path.setAttribute("stroke-width", "2");
  path.setAttribute("stroke-linecap", "round");
  path.setAttribute("stroke-linejoin", "round");
  svg.appendChild(path);
};

const drawLineBetween = (curEl, nextEl, container, svg) => {
  const containerRect = container.getBoundingClientRect();
  const curRect = curEl.getBoundingClientRect();
  const nextRect = nextEl.getBoundingClientRect();

  const goingRight =
    curRect.left + curRect.width / 2 < nextRect.left + nextRect.width / 2;

  const startX =
    (goingRight ? curRect.right : curRect.left) -
    containerRect.left +
    container.scrollLeft;
  const startY =
    curRect.top - containerRect.top + curRect.height / 2 + container.scrollTop;

  const endX =
    (goingRight ? nextRect.left : nextRect.right) -
    containerRect.left +
    container.scrollLeft;
  const endY =
    nextRect.top - containerRect.top + nextRect.height / 2 + container.scrollTop;

  const middleX = startX + (endX - startX) / 2;
  createPath(svg, `M ${startX} ${startY} H ${middleX} V ${endY} H ${endX}`);
};

const connectByAsalMatch = (container, svg) => {
  const sudahDigambar = new Set();

  matches.value.forEach((m) => {
    if (m.ronde === 1) return;

    const nextEl = container.querySelector(`[data-match-id="${m.id}"]`);
    if (!nextEl) return;

    [m.asal_match1_id, m.asal_match2_id].forEach((asalId) => {
      if (!asalId) return;
      const key = `${asalId}->${m.id}`;
      if (sudahDigambar.has(key)) return;

      const curEl = container.querySelector(`[data-match-id="${asalId}"]`);
      if (!curEl) return;

      drawLineBetween(curEl, nextEl, container, svg);
      sudahDigambar.add(key);
    });
  });

  return new Set(matches.value.filter((m) => m.ronde > 1).map((m) => m.id));
};

const connectPlaceholderFallback = (columns, container, svg, sudahAsli) => {
  for (let i = 0; i < columns.length - 1; i++) {
    const curMatches = [...columns[i].querySelectorAll(".esport-match-card")];
    const nextMatches = [...columns[i + 1].querySelectorAll(".esport-match-card")];
    if (!curMatches.length || !nextMatches.length) continue;

    curMatches.forEach((curCard, idx) => {
      const nextCard = nextMatches[Math.floor(idx / 2)];
      if (!nextCard) return;

      const nextIdRaw = nextCard.dataset.matchId;
      const nextIdNum = Number(nextIdRaw);
      if (nextIdRaw && !Number.isNaN(nextIdNum) && sudahAsli.has(nextIdNum)) return;

      drawLineBetween(curCard, nextCard, container, svg);
    });
  }
};

const connectToFinalPlaceholder = (semiColumn, container, svg, sudahAsli) => {
  if (!semiColumn) return;
  const finalCard = container.querySelector(".final-card-wrap .esport-match-card");
  const card = semiColumn.querySelector(".esport-match-card");
  if (!finalCard || !card) return;

  const finalIdRaw = finalCard.dataset.matchId;
  const finalIdNum = Number(finalIdRaw);
  if (finalIdRaw && !Number.isNaN(finalIdNum) && sudahAsli.has(finalIdNum)) return;

  drawLineBetween(card, finalCard, container, svg);
};

const drawBracketLines = (targetContainer, targetSvg) => {
  const isCustomEl =
    targetContainer &&
    typeof targetContainer === "object" &&
    targetContainer.nodeType === 1;
  const container = isCustomEl ? targetContainer : bracketScroll.value;
  const svg =
    targetSvg && typeof targetSvg === "object" && targetSvg.nodeType === 1
      ? targetSvg
      : bracketSvg.value;
  if (!container || !svg) return;

  svg.style.width = container.scrollWidth + "px";
  svg.style.height = container.scrollHeight + "px";
  svg.setAttribute("width", container.scrollWidth + "px");
  svg.setAttribute("height", container.scrollHeight + "px");
  svg.setAttribute("viewBox", `0 0 ${container.scrollWidth} ${container.scrollHeight}`);
  svg.innerHTML = "";

  const leftColumns = [
    ...container.querySelectorAll(".bracket-half-left .bracket-column"),
  ];
  const rightColumns = [
    ...container.querySelectorAll(".bracket-half-right .bracket-column"),
  ].reverse();

  const sudahAsli = connectByAsalMatch(container, svg);

  if (leftColumns.length > 1)
    connectPlaceholderFallback(leftColumns, container, svg, sudahAsli);
  if (rightColumns.length > 1)
    connectPlaceholderFallback(rightColumns, container, svg, sudahAsli);

  if (leftColumns.length)
    connectToFinalPlaceholder(
      leftColumns[leftColumns.length - 1],
      container,
      svg,
      sudahAsli
    );
  if (rightColumns.length)
    connectToFinalPlaceholder(
      rightColumns[rightColumns.length - 1],
      container,
      svg,
      sudahAsli
    );
};

const handleBracketResize = () => {
  requestAnimationFrame(() => drawBracketLines());
  checkScrollBounds();
};

onMounted(async () => {
  await fetchBracket();
  await nextTick();
  checkScrollBounds();
  window.addEventListener("resize", handleBracketResize);
  window.addEventListener("dragover", handleGlobalDragOver, { passive: true });
  window.addEventListener("dragend", stopDragAndAutoScroll);
  window.addEventListener("drop", stopDragAndAutoScroll);
  window.addEventListener("keydown", handleHandModeKey);
  window.addEventListener("keyup", handleHandModeKeyUp);
  window.addEventListener("blur", releaseSpace);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleBracketResize);
  window.removeEventListener("dragover", handleGlobalDragOver);
  window.removeEventListener("dragend", stopDragAndAutoScroll);
  window.removeEventListener("drop", stopDragAndAutoScroll);
  window.removeEventListener("keydown", handleHandModeKey);
  window.removeEventListener("keyup", handleHandModeKeyUp);
  window.removeEventListener("blur", releaseSpace);
  window.removeEventListener("mousemove", onPanMouseMove);
  window.removeEventListener("mouseup", endPan);
  window.removeEventListener("blur", endPan);
  stopPanInertia();
  stopAutoScroll();
});
</script>

<style scoped>
.esport-admin-page {
  min-height: 100vh;
  background: radial-gradient(
      circle at top right,
      rgba(1, 140, 116, 0.1),
      transparent 35%
    ),
    radial-gradient(circle at bottom left, rgba(1, 140, 116, 0.05), transparent 30%),
    linear-gradient(135deg, #f5fbfa 0%, #eefbf7 50%, #f8fafc 100%);
  padding-bottom: 70px;
  color: #182433;
}

.navbar {
  position: sticky;
  top: 0;
  z-index: 4;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(15, 23, 42, 0.07);
}
.navbar-inner {
  max-width: 1240px;
  margin: auto;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}
.logo-wrapper {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 13px;
  border: 1px solid rgba(1, 140, 116, 0.08);
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.08);
}
.logo {
  width: 34px;
  height: 34px;
  object-fit: contain;
}
.logo-section h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #182433;
  display: flex;
  align-items: center;
  gap: 8px;
}
.admin-tag {
  font-size: 10px;
  font-weight: 800;
  color: #018c74;
  background: rgba(1, 140, 116, 0.1);
  padding: 3px 8px;
  border-radius: 6px;
  letter-spacing: 0.4px;
}
.logo-section p {
  margin: 2px 0 0;
  font-size: 11px;
  color: #64748b;
}

.esport-container {
  max-width: 1240px;
  margin: 28px auto;
  padding: 0 20px;
}

.modern-card {
  background: rgba(255, 255, 255, 0.94) !important;
  border: 1px solid rgba(15, 23, 42, 0.07) !important;
  border-radius: 22px !important;
  box-shadow: 0 15px 45px rgba(15, 23, 42, 0.055) !important;
}

.section-heading {
  margin-bottom: 22px;
}
.eyebrow {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  color: #018c74;
  margin-bottom: 8px;
}
.section-heading h1 {
  margin: 0 0 5px;
  font-size: 27px;
  line-height: 1.15;
  font-weight: 850;
  letter-spacing: -0.5px;
  color: #182433;
}
.section-heading p {
  margin: 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.65;
  max-width: 680px;
}

.pilih-card {
  padding: 16px 18px;
  margin-bottom: 18px;
}
.pilih-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.pilih-info {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  color: #475569;
}
.pilih-info strong {
  color: #018c74;
  font-weight: 800;
}
.pilih-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.refresh-btn,
.export-btn {
  min-width: 112px;
  border-radius: 11px !important;
  text-transform: none !important;
  font-weight: 700;
}
.refresh-btn {
  color: #018c74 !important;
  background: #ffffff !important;
  border: 1px solid rgba(1, 140, 116, 0.18);
}
.refresh-btn:hover {
  background: #f0faf7 !important;
}
.export-btn {
  color: #ffffff !important;
  background: #018c74 !important;
  border: none;
  box-shadow: 0 5px 15px rgba(1, 140, 116, 0.2);
}
.reset-btn-outline {
  min-width: 132px;
  border-radius: 11px !important;
  text-transform: none !important;
  font-weight: 700;
  color: #dc2626 !important;
  background: #ffffff !important;
  border: 1px solid rgba(220, 38, 38, 0.2) !important;
}
.reset-btn-outline:hover {
  background: #fff7f7 !important;
}

.screenshot-top-btn {
  min-width: 145px;
  height: 38px !important;
  border-radius: 11px !important;
  text-transform: none !important;
  font-weight: 750 !important;
  font-size: 12.5px !important;
  color: #018c74 !important;
  background: #ffffff !important;
  border: 1px solid rgba(1, 140, 116, 0.28) !important;
  box-shadow: 0 2px 8px rgba(1, 140, 116, 0.08) !important;
  transition: all 0.2s ease;
}
.screenshot-top-btn:hover {
  background: #f0faf7 !important;
  border-color: #018c74 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(1, 140, 116, 0.16) !important;
}

.screenshot-action-btn {
  height: 30px !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 750 !important;
  font-size: 11.5px !important;
  color: #018c74 !important;
  background: #ffffff !important;
  border: 1px solid rgba(1, 140, 116, 0.28) !important;
  box-shadow: 0 2px 6px rgba(1, 140, 116, 0.08) !important;
  padding: 0 11px !important;
  transition: all 0.2s ease;
}
.screenshot-action-btn:hover {
  background: #f0faf7 !important;
  border-color: #018c74 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(1, 140, 116, 0.16) !important;
}

.empty-bracket-card {
  padding: 55px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  margin-bottom: 18px;
}
.empty-icon {
  width: 74px;
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: rgba(1, 140, 116, 0.08);
  border: 1px solid rgba(1, 140, 116, 0.1);
  margin-bottom: 5px;
}
.empty-bracket-card h3 {
  margin: 5px 0 0;
  font-size: 19px;
  font-weight: 800;
}
.empty-bracket-card p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.7;
  max-width: 580px;
}
.empty-bracket-card p strong {
  color: #334155;
}
.empty-bracket-card .export-btn {
  margin-top: 12px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 18px;
}
.summary-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 18px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(15, 23, 42, 0.07);
  border-radius: 17px;
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.04);
  overflow: hidden;
}
.summary-card::after {
  content: "";
  position: absolute;
  right: -20px;
  bottom: -20px;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background: rgba(1, 140, 116, 0.035);
}
.summary-icon {
  width: 43px;
  height: 43px;
  flex: 0 0 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}
.summary-card span {
  display: block;
  font-size: 10px;
  color: #94a3b8;
  margin-bottom: 4px;
  font-weight: 600;
}
.summary-card strong {
  font-size: 20px;
  line-height: 1;
  color: #1e293b;
  font-weight: 850;
}
.summary-card strong.cap {
  text-transform: capitalize;
}
.summary-card.total .summary-icon {
  color: #6366f1;
  background: #eef2ff;
}
.summary-card.ai .summary-icon {
  color: #3b82f6;
  background: #eff6ff;
}
.summary-card.menunggu .summary-icon {
  color: #d97706;
  background: #fffbeb;
}
.summary-card.diterima .summary-icon {
  color: #018c74;
  background: #ecfdf5;
}

.juara-card {
  padding: 20px;
  margin-bottom: 18px;
}
.juara-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  margin-bottom: 14px;
}
.juara-title strong {
  font-weight: 800;
}
.juara-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
.juara-box {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border-radius: 14px;
  min-height: 70px;
}
.juara-number {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 900;
  background: rgba(255, 255, 255, 0.75);
}
.juara-box span {
  display: block;
  font-size: 9px;
  color: #94a3b8;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 3px;
}
.juara-box strong {
  display: block;
  font-size: 13px;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.juara-box.juara-1 {
  background: #fffbeb;
  border: 1px solid rgba(217, 119, 6, 0.25);
}
.juara-box.juara-1 .juara-number {
  color: #d97706;
  border: 1px solid rgba(217, 119, 6, 0.18);
}
.juara-box.juara-2 {
  background: #f1f5f9;
  border: 1px solid rgba(100, 116, 139, 0.25);
}
.juara-box.juara-2 .juara-number {
  color: #64748b;
}
.juara-box.juara-3 {
  background: #ecfdf5;
  border: 1px solid rgba(1, 140, 116, 0.2);
}
.juara-box.juara-3 .juara-number {
  color: #018c74;
}
.juara-box.juara-4 {
  background: #eff6ff;
  border: 1px solid rgba(59, 130, 246, 0.2);
}
.juara-box.juara-4 .juara-number {
  color: #3b82f6;
}

.bracket-scroll-card {
  position: relative;
  margin-bottom: 18px;
  overflow: hidden;
}
.table-title {
  min-height: 68px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid #edf2f5;
  background: rgba(255, 255, 255, 0.75);
}
.table-title-left {
  display: flex;
  align-items: center;
  gap: 11px;
}
.table-title-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(1, 140, 116, 0.08);
}
.table-title strong {
  display: block;
  font-size: 14px;
  font-weight: 850;
  color: #1e293b;
}
.table-title span {
  display: block;
  font-size: 11px;
  color: #94a3b8;
  margin-top: 3px;
}

.bracket-nav-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.screenshot-action-btn {
  height: 34px !important;
  border-radius: 9px !important;
  border: 1px solid #cbd5e1 !important;
  background: #ffffff !important;
  color: #018c74 !important;
  font-weight: 800 !important;
  font-size: 11.5px !important;
  text-transform: none !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.18s ease !important;
}
.screenshot-action-btn:hover {
  background: #f0faf7 !important;
  border-color: #018c74 !important;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(1, 140, 116, 0.15) !important;
}

/* ===== Toggle Mode Pilih / Tangan ===== */
.mode-pill-group {
  display: inline-flex;
  align-items: center;
  background: #f1f5f9;
  padding: 3px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  gap: 2px;
}
.mode-pill-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 7px;
  border: none;
  background: transparent;
  font-size: 11px;
  font-weight: 800;
  color: #475569;
  cursor: pointer;
  transition: all 0.18s ease;
  line-height: 1;
}
.mode-pill-btn .v-icon {
  color: inherit !important;
}
.mode-pill-btn:hover {
  background: #ffffff;
  color: #018c74;
}
.mode-pill-btn.active {
  background: #018c74;
  color: #ffffff;
  box-shadow: 0 3px 9px rgba(1, 140, 116, 0.3);
}
.mode-kbd {
  display: inline-block;
  min-width: 15px;
  padding: 2px 4px;
  border-radius: 4px;
  border: 1px solid rgba(100, 116, 139, 0.35);
  background: rgba(255, 255, 255, 0.7);
  font-family: inherit;
  font-size: 9px;
  font-weight: 800;
  line-height: 1;
  text-align: center;
  color: #64748b;
}
.mode-pill-btn.active .mode-kbd {
  border-color: rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
}
.mode-pill-btn.active:hover {
  background: #017662;
  color: #ffffff;
}

.jump-pill-group {
  display: inline-flex;
  align-items: center;
  background: #f1f5f9;
  padding: 3px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  gap: 2px;
}
.jump-pill-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 9px;
  border-radius: 7px;
  border: none;
  background: transparent;
  font-size: 11px;
  font-weight: 800;
  color: #475569;
  cursor: pointer;
  transition: all 0.18s ease;
  line-height: 1;
}
.jump-pill-btn:hover {
  background: #ffffff;
  color: #018c74;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
}
.jump-pill-btn.final-pill:hover {
  color: #d97706;
}
.step-nav-group {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.step-nav-btn {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
  cursor: pointer;
  transition: all 0.18s ease;
}
.step-nav-btn:hover:not(:disabled) {
  border-color: #018c74;
  color: #018c74;
  background: #f0faf7;
  box-shadow: 0 2px 6px rgba(1, 140, 116, 0.15);
}
.step-nav-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

/* ===== Hint Mode Tangan ===== */
.hand-mode-hint {
  position: absolute;
  left: 50%;
  bottom: 18px;
  transform: translateX(-50%);
  z-index: 26;
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.82);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.28);
}
.hand-mode-hint em {
  font-style: normal;
  font-weight: 600;
  color: #94a3b8;
  margin-left: 4px;
}

.drag-scroll-guide {
  position: absolute;
  top: 68px;
  bottom: 0;
  width: 140px;
  pointer-events: none;
  z-index: 25;
  display: flex;
  align-items: center;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.drag-scroll-guide.left-guide {
  left: 0;
  background: linear-gradient(
    to right,
    rgba(1, 140, 116, 0.22) 0%,
    rgba(1, 140, 116, 0.06) 65%,
    transparent 100%
  );
  border-left: 4px solid #018c74;
  padding-left: 14px;
}
.drag-scroll-guide.right-guide {
  right: 0;
  background: linear-gradient(
    to left,
    rgba(1, 140, 116, 0.22) 0%,
    rgba(1, 140, 116, 0.06) 65%,
    transparent 100%
  );
  border-right: 4px solid #018c74;
  padding-right: 14px;
  justify-content: flex-end;
}
.drag-scroll-guide.active {
  width: 175px;
}
.drag-scroll-guide.left-guide.active {
  background: linear-gradient(
    to right,
    rgba(1, 140, 116, 0.4) 0%,
    rgba(1, 140, 116, 0.14) 75%,
    transparent 100%
  );
  box-shadow: inset 10px 0 20px -5px rgba(1, 140, 116, 0.35);
}
.drag-scroll-guide.right-guide.active {
  background: linear-gradient(
    to left,
    rgba(1, 140, 116, 0.4) 0%,
    rgba(1, 140, 116, 0.14) 75%,
    transparent 100%
  );
  box-shadow: inset -10px 0 20px -5px rgba(1, 140, 116, 0.35);
}

.drag-guide-content {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid rgba(1, 140, 116, 0.25);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);
}
.drag-guide-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}
.drag-guide-text.right-align {
  text-align: right;
}
.drag-guide-text strong {
  font-size: 11px;
  font-weight: 850;
  color: #018c74;
}
.drag-guide-text small {
  font-size: 9px;
  color: #64748b;
  font-weight: 600;
}
.drag-guide-icon-pulse {
  animation: pulseGuide 1.2s infinite ease-in-out;
}
@keyframes pulseGuide {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.85;
  }
  50% {
    transform: scale(1.25);
    opacity: 1;
  }
}

.drag-scroll-guide-v {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  pointer-events: none;
  animation: floatBounce 0.8s infinite alternate ease-in-out;
}
.drag-scroll-guide-v.top-guide-v {
  top: 78px;
}
.drag-scroll-guide-v.bottom-guide-v {
  bottom: 24px;
}
@keyframes floatBounce {
  0% {
    transform: translate(-50%, 0);
  }
  100% {
    transform: translate(-50%, -4px);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.bracket-scroll {
  position: relative;
  padding: 20px 28px 72px;
  overflow-x: auto;
  overflow-y: hidden;
  min-height: 460px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
  -webkit-overflow-scrolling: touch;
}

/* ===== Mode Tangan: kursor grab, tanpa seleksi teks ===== */
.bracket-scroll.hand-mode {
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
}
.bracket-scroll.hand-mode * {
  cursor: grab !important;
  user-select: none !important;
  -webkit-user-select: none !important;
  -webkit-user-drag: none;
}
.bracket-scroll.is-panning,
.bracket-scroll.is-panning * {
  cursor: grabbing !important;
  user-select: none !important;
  -webkit-user-select: none !important;
}

.bracket-track {
  display: flex;
  align-items: stretch;
  gap: 28px;
  width: max-content;
  min-width: max-content;
  margin: 0 auto;
  flex-wrap: nowrap;
}
.bracket-scroll::-webkit-scrollbar {
  height: 8px;
}
.bracket-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.bracket-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}
.bracket-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.bracket-svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: visible;
}

.bracket-side-group {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 0 0 auto;
}
.bracket-side-group-right {
  align-items: flex-end;
}
.bracket-side-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(1, 140, 116, 0.08);
  border: 1px solid rgba(1, 140, 116, 0.16);
  font-size: 11px;
  font-weight: 850;
  color: #018c74;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  white-space: nowrap;
  width: fit-content;
}

.bracket-half {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: stretch;
  gap: 40px;
  flex: 1 1 auto;
  flex-wrap: nowrap;
}

.bracket-column {
  position: relative;
  flex: 0 0 250px;
  width: 250px;
  min-width: 250px;
  display: flex;
  flex-direction: column;
}

.bracket-column-header {
  height: 36px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 0 4px;
  font-size: 10px;
  font-weight: 850;
  color: #018c74;
  text-transform: uppercase;
  letter-spacing: 0.7px;
}
.bracket-half-right .bracket-column-header {
  justify-content: flex-end;
}
.bracket-column-action {
  height: 44px;
  flex: 0 0 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.acak-ronde-btn {
  width: 100%;
  height: 34px !important;
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 800 !important;
  font-size: 12px !important;
  letter-spacing: 0.2px;
  color: #ffffff !important;
  background: #018c74 !important;
  box-shadow: 0 4px 12px rgba(1, 140, 116, 0.28) !important;
}
.acak-ronde-btn:hover {
  background: #017662 !important;
}
.round-icon {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(1, 140, 116, 0.08);
  flex: 0 0 auto;
}
.bracket-column-header span {
  white-space: nowrap;
}

.bracket-column-cards {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.bracket-column-body {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  justify-content: center;
  padding: 15px 0;
}

.bracket-center {
  position: relative;
  z-index: 2;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
  padding: 0 6px;
  width: 262px;
  min-width: 262px;
}
.center-spacer {
  visibility: hidden;
  pointer-events: none;
  align-self: center;
}
.center-spacer-header {
  visibility: hidden;
  pointer-events: none;
  flex: 0 0 36px;
  margin-bottom: -14px;
}
.center-spacer-action {
  visibility: hidden;
  pointer-events: none;
  flex: 0 0 44px;
  margin-bottom: -14px;
}
.bracket-center-body {
  flex: 1;
  width: 100%;
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  justify-items: center;
  padding: 15px 0;
}
.final-block {
  display: contents;
}
.final-block .final-label {
  grid-row: 1;
  align-self: end;
}
.final-card-wrap {
  grid-row: 2;
}
.j3-block {
  grid-row: 3;
  align-self: start;
  margin-top: 18px;
}
.final-label,
.j3-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.final-label {
  color: #d97706;
}
.j3-label {
  color: #3b82f6;
}
.j3-block {
  opacity: 0.9;
}

@media (max-width: 1100px) {
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .juara-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .esport-container {
    margin: 20px auto;
    padding: 0 12px;
  }
  .section-heading h1 {
    font-size: 23px;
  }
  .pilih-inner {
    align-items: flex-start;
  }
  .pilih-actions {
    width: 100%;
  }
  .pilih-actions .v-btn {
    flex: 1;
  }
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .juara-grid {
    grid-template-columns: 1fr;
  }
  .table-title {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .bracket-hint {
    display: none;
  }
  .hand-mode-hint {
    bottom: 10px;
    font-size: 10px;
    padding: 6px 11px;
  }
  .hand-mode-hint em {
    display: none;
  }
  .bracket-scroll {
    padding: 14px 16px 72px;
    min-height: 480px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .bracket-track {
    gap: 28px;
    width: max-content;
    min-width: max-content;
    flex-wrap: nowrap;
  }
  .bracket-half {
    gap: 40px;
    flex: 1 1 auto;
    flex-wrap: nowrap;
  }
  .bracket-column {
    flex: 0 0 250px;
    width: 250px;
    min-width: 250px;
  }
  .bracket-center {
    flex: 0 0 auto;
    width: 262px;
    min-width: 262px;
  }
}

@media (max-width: 480px) {
  .navbar-inner {
    padding: 12px 14px;
  }
  .logo-wrapper {
    width: 40px;
    height: 40px;
  }
  .logo {
    width: 30px;
    height: 30px;
  }
  .logo-section h2 {
    font-size: 14px;
  }
  .logo-section p {
    font-size: 10px;
  }
  .admin-tag {
    display: none;
  }
  .pilih-actions {
    flex-direction: column;
  }
  .pilih-actions .v-btn {
    width: 100%;
  }
  .bracket-scroll {
    padding: 12px 12px 72px;
    min-height: 460px;
  }
  .bracket-track {
    gap: 24px;
    width: max-content;
    min-width: max-content;
    flex-wrap: nowrap;
  }
  .bracket-half {
    gap: 36px;
    flex: 1 1 auto;
    flex-wrap: nowrap;
  }
}

.bracket-add-match {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 8px;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  color: #94a3b8;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.bracket-add-match .v-icon,
.bracket-add-match span {
  animation: bracketAddBlink 1.2s ease-in-out infinite;
}

@keyframes bracketAddBlink {
  0%,
  100% {
    color: #94a3b8;
  }
  50% {
    color: #f59e0b;
  }
}

.bracket-add-match.drop-hover {
  border-color: #018c74;
  color: #018c74;
  background: rgba(1, 140, 116, 0.06);
}

.bracket-add-match.drop-hover .v-icon,
.bracket-add-match.drop-hover span {
  animation: none;
  color: #018c74 !important;
}
</style>

<style>
.screenshot-preview-dialog {
  border-radius: 20px !important;
  overflow: hidden !important;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.4) !important;
}

.screenshot-dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
  background: #ffffff !important;
  display: flex;
  flex-direction: column;
}

.screenshot-dialog-header {
  padding: 16px 22px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.screenshot-dialog-header .header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.header-icon-box {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(1, 140, 116, 0.1);
  border: 1px solid rgba(1, 140, 116, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.header-title-text {
  min-width: 0;
}

.screenshot-dialog-header h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 850;
  color: #1e293b;
}

.screenshot-dialog-header p {
  margin: 3px 0 0;
  font-size: 12px;
  color: #64748b;
}

.dot-separator {
  margin: 0 6px;
  color: #cbd5e1;
}

.header-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.zoom-pill-group {
  display: inline-flex;
  align-items: center;
  background: #f1f5f9;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 2px;
}

.zoom-btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s ease;
}

.zoom-btn:hover:not(:disabled) {
  background: #ffffff;
  color: #018c74;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.zoom-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.zoom-value {
  padding: 0 10px;
  font-size: 11px;
  font-weight: 750;
  color: #334155;
  min-width: 48px;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.tool-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 11px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s ease;
  height: 32px;
}

.tool-btn:hover,
.tool-btn.active {
  border-color: #018c74;
  color: #018c74;
  background: #f0faf7;
}

.close-dialog-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s ease;
}

.close-dialog-btn:hover {
  background: #fee2e2;
  color: #ef4444;
  border-color: #fca5a5;
}

.mobile-close-btn {
  display: none;
}

.desktop-close-btn {
  display: inline-flex;
}

.screenshot-dialog-body {
  padding: 16px 20px !important;
  background: #0f172a !important;
}

.screenshot-canvas-viewport {
  width: 100%;
  max-height: 64vh;
  overflow: auto;
  border-radius: 12px;
  background: #1e293b;
  box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.4);
  padding: 20px;
  text-align: center;
  scrollbar-width: thin;
  scrollbar-color: #475569 #1e293b;
}

.screenshot-canvas-viewport::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.screenshot-canvas-viewport::-webkit-scrollbar-track {
  background: #1e293b;
}

.screenshot-canvas-viewport::-webkit-scrollbar-thumb {
  background: #475569;
  border-radius: 4px;
}

.screenshot-img-container {
  display: block;
  margin: 0 auto;
  transition: width 0.15s ease-out, min-width 0.15s ease-out;
}

.screenshot-result-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.viewport-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  font-size: 11px;
  color: #94a3b8;
}

.screenshot-dialog-footer {
  padding: 14px 22px !important;
  background: #ffffff !important;
  border-top: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.footer-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-name-preview {
  font-size: 12px;
  color: #64748b;
  font-family: monospace;
  background: #f1f5f9;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.footer-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-secondary-btns {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cancel-btn {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  color: #64748b !important;
  border: 1px solid #cbd5e1 !important;
  background: #ffffff !important;
}

.cancel-btn:hover {
  background: #f1f5f9 !important;
  color: #334155 !important;
}

.open-tab-btn {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.35) !important;
  background: #ffffff !important;
}

.open-tab-btn:hover {
  background: #f0faf7 !important;
}

.download-btn {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 750 !important;
  background: #018c74 !important;
  color: #ffffff !important;
  box-shadow: 0 4px 14px rgba(1, 140, 116, 0.3) !important;
}

.download-btn:hover {
  background: #017662 !important;
}

@media (max-width: 768px) {
  .table-title {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 12px !important;
    padding: 12px 14px !important;
  }
  .bracket-nav-controls {
    justify-content: space-between !important;
    gap: 8px !important;
    width: 100% !important;
  }
  .screenshot-action-btn {
    flex: 1 1 auto !important;
    height: 32px !important;
    font-size: 11px !important;
    padding: 0 8px !important;
  }
}

@media (max-width: 680px) {
  .screenshot-preview-dialog {
    margin: 6px !important;
    width: calc(100vw - 12px) !important;
    max-width: calc(100vw - 12px) !important;
    max-height: 96vh !important;
    border-radius: 16px !important;
  }

  .screenshot-dialog-card {
    height: 94vh !important;
    max-height: 94vh !important;
    border-radius: 16px !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }

  .screenshot-dialog-header {
    padding: 10px 12px !important;
    gap: 8px !important;
    flex-shrink: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .screenshot-dialog-header .header-left {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: 100% !important;
    gap: 8px !important;
  }

  .header-icon-box {
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    border-radius: 8px !important;
  }

  .screenshot-dialog-header h3 {
    font-size: 13px !important;
    line-height: 1.2 !important;
  }

  .screenshot-dialog-header p {
    font-size: 10px !important;
    margin-top: 1px !important;
  }

  .mobile-close-btn {
    display: inline-flex !important;
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    margin-left: auto !important;
  }

  .desktop-close-btn {
    display: none !important;
  }

  .header-tools {
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 4px !important;
  }

  .zoom-pill-group {
    padding: 1px !important;
  }

  .zoom-btn {
    width: 26px !important;
    height: 26px !important;
  }

  .zoom-value {
    font-size: 10px !important;
    min-width: 36px !important;
    padding: 0 3px !important;
  }

  .tool-btn {
    height: 28px !important;
    padding: 0 7px !important;
    font-size: 10px !important;
    gap: 3px !important;
  }

  .screenshot-dialog-body {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    padding: 8px 10px !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }

  .screenshot-canvas-viewport {
    flex: 1 1 auto !important;
    min-height: 100px !important;
    max-height: none !important;
    height: 100% !important;
    padding: 8px !important;
    overflow: auto !important;
    -webkit-overflow-scrolling: touch;
    border-radius: 10px !important;
  }

  .viewport-hint {
    margin-top: 4px !important;
    font-size: 9.5px !important;
  }

  .screenshot-dialog-footer {
    flex-shrink: 0 !important;
    padding: 10px 12px 12px !important;
    gap: 8px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    background: #ffffff !important;
    border-top: 1px solid #e2e8f0 !important;
    box-shadow: 0 -3px 12px rgba(0, 0, 0, 0.05) !important;
  }

  .footer-meta {
    display: none !important;
  }

  .footer-buttons {
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 8px !important;
  }

  .footer-secondary-btns {
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 8px !important;
  }

  .cancel-btn {
    flex: 1 1 50% !important;
    height: 38px !important;
    min-height: 38px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    border-radius: 9px !important;
    border: 1px solid #cbd5e1 !important;
    background: #f8fafc !important;
    color: #475569 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .open-tab-btn {
    flex: 1 1 50% !important;
    height: 38px !important;
    min-height: 38px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    border-radius: 9px !important;
    border: 1px solid rgba(1, 140, 116, 0.4) !important;
    background: #f0faf7 !important;
    color: #018c74 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .download-btn {
    width: 100% !important;
    height: 42px !important;
    min-height: 42px !important;
    padding: 0 14px !important;
    font-size: 13px !important;
    font-weight: 800 !important;
    letter-spacing: 0.2px !important;
    border-radius: 9px !important;
    background: #018c74 !important;
    color: #ffffff !important;
    box-shadow: 0 3px 12px rgba(1, 140, 116, 0.3) !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    white-space: nowrap !important;
  }
}
</style>
